import { AppState, AppThunkDispatch } from "../..";
import { AssetManagementRequest } from "../../../entities/asset-management/asset-management-request";
import ManualOnboardingService from "../../../services/asset-management";
import { enqueueSnackbarAction } from "../../snackbar/actions";

const ManualOnboarding = (input: AssetManagementRequest) => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
  const {
    login: { client, envVariables },
  } = getState();

  const assetManagment = new ManualOnboardingService(client, envVariables.assetManagementBaseURL);
  try {
    const response = await assetManagment.assetManualOnboarding(input);
    if (response.status === 201) {
      dispatch(
        enqueueSnackbarAction({
          message: `Successfully created new asset.`,
          options: { variant: 'success' },
        }),
      );
      return null;
    }
  } catch (error: any) {
    dispatch(
      enqueueSnackbarAction({
        message: `Failed to create new asset: ${error}`,
        options: { variant: 'error' },
      }),
    )
  }
  return null;
};

export const createNewAsset = (input: any) => async (dispatch: AppThunkDispatch) => {
  await dispatch(ManualOnboarding(input));
  return null;
};